import _classCallCheck from 'babel-runtime/helpers/classCallCheck';
import _createClass from 'babel-runtime/helpers/createClass';
import _possibleConstructorReturn from 'babel-runtime/helpers/possibleConstructorReturn';
import _inherits from 'babel-runtime/helpers/inherits';
import React, { Component } from 'react';
import RadioGroup from '../radio/radio_group.js';
import CheckboxGroup from '../checkbox/checkbox_group.js';
import { htmlDecode } from '../helpers.js';
import './variant_option.css';

var VariantOptions = function (_Component) {
	_inherits(VariantOptions, _Component);

	function VariantOptions() {
		_classCallCheck(this, VariantOptions);

		return _possibleConstructorReturn(this, (VariantOptions.__proto__ || Object.getPrototypeOf(VariantOptions)).call(this));
	}

	_createClass(VariantOptions, [{
		key: 'render',
		value: function render() {
			var _props = this.props,
			    shopify_product = _props.shopify_product,
			    select_by = _props.select_by,
			    show_quantity = _props.show_quantity,
			    step_index = _props.step_index,
			    setVariantCheckbox = _props.setVariantCheckbox,
			    setVariantRadio = _props.setVariantRadio,
			    wkSelectedOptions = _props.wkSelectedOptions,
			    updateQuantity = _props.updateQuantity,
			    selection = _props.selection;


			return React.createElement(
				'div',
				{ className: 'selection_section' },
				shopify_product.options && shopify_product.options.map(function (option, index) {

					switch (select_by) {
						case 'radio':
							return React.createElement(RadioGroup, {
								key: 'radiogroup-' + index,
								shopify_product_title: shopify_product.title,
								title: option.name,
								options: option.values,
								wkSelectedOptions: wkSelectedOptions,
								step_index: step_index,
								itemAction: setVariantRadio });
						case 'checkbox':
							return React.createElement(CheckboxGroup, {
								key: 'checkboxgroup-' + index, shopify_product_title: shopify_product.title, title: option.name,
								options: option.values,
								wkSelectedOptions: wkSelectedOptions,
								step_index: step_index,
								show_quantity: show_quantity,
								itemAction: setVariantCheckbox,
								updateQuantity: updateQuantity });
					}
				}),
				selection.selection_note && React.createElement('div', { className: 'selection_note', dangerouslySetInnerHTML: { __html: htmlDecode(selection.selection_note) } })
			);
		}
	}]);

	return VariantOptions;
}(Component);

export default VariantOptions;